<script lang="ts">
	//UI
	import RangePresets from "@hitit/hub/src/v7/components/common/RangePresets.svelte";
	import DateRange from "@hitit/hub/src/v7/components/common/DateRange.svelte";
	import TotalRevenue from "@hitit/hub/src/v7/components/revenue/TotalRevenue.svelte";
	import CardCashRevenue from "@hitit/hub/src/v7/components/revenue/CardCashRevenue.svelte";
	import DownloadImage from "@hitit/hub/src/assets/Icons/DownloadIcon.png";
	import OrderHistory from "../component/Revenue/OrderHistory.svelte";
	import { HubProfileBottomLineButton } from "@hitit/new_ui";

	//Utils
	import {
		timeStringToDate,
		writeSalesReportExcel,
	} from "@hitit/hub/src/v7/utils";
	import { formatISO, startOfDay, endOfDay, isValid } from "date-fns";
	import { api, notifications, t } from "@hitit/hub/src/stores";
	import { onDestroy } from "svelte";
	import { popup } from "@hitit/hub/src/v7/store";
	import queryString from "query-string";
	import { globalHistory } from "svelte-routing/src/history";
	import { navigate } from "svelte-routing";
	import moment from "moment";

	//Types
	type RangeHandlerEvent = { detail: { start: Date; end: Date } };
	type locationOverload = { search: string; pathname: string };
	//Constants
	const theFirstQuery = parseQuerystring(window.location.search);
	//Props
	export let storeId = "";
	export let range = {
		start: theFirstQuery.startTime,
		end: theFirstQuery.endTime,
	};
	//Variables
	let salesDerived = createSalesDerived();
	let gettingSalesReport = false;
	let page = theFirstQuery.page;
	//Functions
	function createSalesDerived() {
		return {
			total: {
				amount: 0,
				count: 0,
				discount: 0,
			},
			cardCash: {
				card: {
					amount: 0,
					count: 0,
					discount: 0,
				},
				cash: {
					amount: 0,
					count: 0,
					discount: 0,
				},
			},
		};
	}

	async function loadSalesReports(qRange: Interval, qStoreId: string) {
		try {
			gettingSalesReport = true;

			const reportSalesPromise = $api.getStoreSalesReport({
				startTimeInTimeZone: formatISO(startOfDay(qRange.start)),
				endTimeInTimeZone: formatISO(endOfDay(qRange.end)),
				reportTimeZone: "ASIA_SEOUL",
				reportResolution: "YEARLY",
				storeid: qStoreId,
			});

			const reportSalesPaymentPromise = $api.getByPayment({
				startTimeInTimeZone: formatISO(startOfDay(qRange.start)),
				endTimeInTimeZone: formatISO(endOfDay(qRange.end)),
				reportTimeZone: "ASIA_SEOUL",
				reportResolution: "YEARLY",
				storeid: qStoreId,
			});

			const [reportSalesPaymentResponse, reportSalesResponse] =
				await Promise.all([reportSalesPaymentPromise, reportSalesPromise]);

			let salesReports = reportSalesResponse.data.salesReports;
			let salesReportStorePayment =
				reportSalesPaymentResponse.data.salesReportsByPaymentMethod;

			const __salesDerived = createSalesDerived();

			for (let report of salesReportStorePayment || []) {
				if (report.paymentMethod === "INSTORE_CASH") {
					__salesDerived.cardCash.cash.amount += report.sum;
					__salesDerived.cardCash.cash.count += report.count;
				}
				if (report.paymentMethod === "INSTORE_CAT") {
					__salesDerived.cardCash.card.amount += report.sum;
					__salesDerived.cardCash.card.count += report.count;
				}
			}

			for (let report of salesReports || []) {
				__salesDerived.total.amount += report.sum;
				__salesDerived.total.count += report.count;
				__salesDerived.total.discount += report.discount;
			}
			salesDerived = __salesDerived;
		} catch {
			salesDerived = createSalesDerived();
			notifications.defaultHandler(new Error("Error"));
		} finally {
			gettingSalesReport = false;
		}
	}

	async function salesExcelReportDownload() {
		const id = Math.floor(Math.random() * 1e9).toString(16);
		const setStatusMessage = (message: string | undefined) => {
			if (message === "DONE") {
				notifications.append(
					"SUCCESS",
					$t("global.done"),
					id,
					true,
					"EXCEL",
					3000
				);
				return;
			}
			notifications.append("INFO", message || "...", id, true, "EXCEL");
		};
		const utils = {
			apiClient: $api,
			t: $t,
			setStatusMessage,
		};
		const ref = {
			storeId: storeId,
			range: range,
		};
		await writeSalesReportExcel(ref, utils);
	}
	function rangeHandler(e: RangeHandlerEvent) {
		navigateController(e.detail.start, e.detail.end, 0);
	}

	function parseQuerystring(query: string) {
		const parsed = queryString.parse(query);
		const { startTime, endTime, page } = parsed;
		const parseDate = timeStringToDate(startTime as string, endTime as string);

		return {
			startTime: parseDate.startTime,
			endTime: parseDate.endTime,
			page: Number(page) || 0,
		};
	}

	function navigateController(
		_startTime = range.start,
		_endTime = range.end,
		_page: number = page
	) {
		const formatedStartTime = moment(_startTime).format("yyyy.MM.DD");
		const formatedEndTime = moment(_endTime).format("yyyy.MM.DD");
		const startUtcQuery = `startTime=${formatedStartTime}&`;
		const endUtcQuery = `endTime=${formatedEndTime}&`;
		const pageQuery = `page=${_page}`;

		const query = startUtcQuery + endUtcQuery + pageQuery;
		navigate(`/store/${storeId}/revenue/saleshistory?` + query);
	}
	//Do
	$: {
		loadSalesReports(range, storeId);
	}
	onDestroy(() => {
		$popup = undefined;
	});
	globalHistory.listen((v) => {
		const query = parseQuerystring((v.location as locationOverload).search);
		const parseRangeStartTime = moment(range.start).format("yyyy.MM.DD");
		const parseQueryStartTime = moment(query.startTime).format("yyyy.MM.DD");
		const parseRangeEndTime = moment(range.end).format("yyyy.MM.DD");
		const parseQueryEndTime = moment(query.endTime).format("yyyy.MM.DD");

		if (
			parseRangeStartTime !== parseQueryStartTime ||
			parseRangeEndTime !== parseQueryEndTime
		) {
			range = { start: query.startTime, end: query.endTime };
		}
		page = query.page;
	});
</script>

<div class="container">
	<div class="header">
		<div class="date-range-container">
			<RangePresets today={new Date()} range={range} on:change={rangeHandler} />
			<DateRange range={range} on:change={rangeHandler} />
		</div>
		<div class="download-container">
			<HubProfileBottomLineButton rightIconVisible={false}>
				<div class="download-container">
					<span on:click={salesExcelReportDownload}>
						{$t("hub.order.Download_sales_data")}
					</span>
					<img src={DownloadImage} alt="Download revenue" />
				</div>
			</HubProfileBottomLineButton>
		</div>
	</div>
	<div class="revenue">
		<div class="total">
			<TotalRevenue
				revenueRef={salesDerived.total}
				loading={gettingSalesReport}
			/>
		</div>
		<div class="card-cash">
			<CardCashRevenue
				revenueRefs={salesDerived.cardCash}
				loading={gettingSalesReport}
			/>
		</div>
	</div>
	<div class="order-history">
		<OrderHistory
			range={range}
			storeId={storeId}
			presentPage={page}
			on:PAGE={(e) => navigateController(undefined, undefined, e.detail)}
		/>
	</div>
</div>

<style lang="scss">
	@import "../../variables.scss";

	//Mobile First
	.container {
		display: flex;
		flex-direction: column;
		gap: 20px;

		.header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;
			gap: 20px 0px;
		}

		.date-range-container {
			display: flex;
			flex-wrap: wrap;
			gap: 12px;
		}

		.download-container {
			display: flex;
			align-items: center;
			gap: 10px;
			span {
				color: #3c68d6;
				font-weight: 500;
			}
			img {
				width: 14px;
				height: 15.8px;
			}
		}

		.revenue {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		.order-history {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	@include DesktopSize {
		.container {
			.revenue {
				flex-direction: row;
				gap: 40px;

				.total {
					max-width: calc((100% * (600 / 1554)) - 20px);
					flex-grow: 600;
				}

				.card-cash {
					max-width: calc((100% * (954 / 1554)) - 20px);
					flex-grow: 954;
					position: relative;

					&::before {
						content: "";
						position: absolute;
						width: 0px;
						height: 0px;
						left: -26px;
						top: 32px;
						border-bottom: 18px solid white;
						border-left: 18px solid transparent;
						border-right: 18px solid transparent;
						transform: rotate(270deg);
					}
				}
			}
		}
	}
</style>
